import t from "@/lang/lang";
import { CreateLabDialog } from "@/services/backend/samples/components/create-lab-dialog";
import { LabTable } from "@/services/backend/samples/components/lab-table";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { useNavigate } from "react-router";

export function LabListRoute() {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Labore")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Labore für die Probenanalyse verwaltet werden. Ein Labor kann für mehrere Analysearten konfiguriert werden.",
          )}
        </CardDescription>
        <CardAction>
          <CreateLabDialog onSuccess={(lab) => navigate(lab.id)} />
        </CardAction>
      </CardHeader>
      <CardContent>
        <LabTable navigateTo={(lab) => navigate(lab.id)} />
      </CardContent>
    </Card>
  );
}
